import { KlientProduktNotifikaceVO } from "../types/Types";
import { api } from "./Api";

const BASE_PATH = '/api/clientNotifications';

export const getClientNotifications = async () => {
    return await api.get<KlientProduktNotifikaceVO[]>(`${BASE_PATH}/get`);
}
